import { ClickNavigationSection } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { ZoomSettings } from './ZoomSettings'

export const ZoomSpecificSettings = (): ClickNavigationSection[] => {
  return [{ id: 'settings', label: 'Zoom Settings', content: () => <ZoomSettings /> }]
}
